import { WorkspaceMemberRole } from '@workspace/domain/workspace';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  value: WorkspaceMemberRole;
  onChange(role: WorkspaceMemberRole): void;
  disabled: boolean;
  excludeAdminRole: boolean;
};

export const WorkspaceRoleSelect: React.FC<Props> = ({ value, onChange, disabled, excludeAdminRole }: Props) => {
  const { t } = useTranslation();
  const handleChangeRole = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      onChange(WorkspaceMemberRole.load(event.target.value));
    },
    [onChange]
  );

  return (
    <div>
      <select
        className="form-select m-1 py-1 text-sm"
        value={value.toString()}
        onChange={handleChangeRole}
        disabled={disabled}
      >
        {WorkspaceMemberRole.values()
          .filter((role) => (excludeAdminRole ? role !== WorkspaceMemberRole.admin : true))
          .map((role) => (
            <option key={role} value={role}>
              {t(WorkspaceMemberRole.getLocalStringKey(role))}
            </option>
          ))}
      </select>
    </div>
  );
};
